import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import type {PillProps} from './pill.types';
import {PillSize, PillType} from './pill.types';
import styles from './pill.module.scss';

export function Pill({label, type = PillType.NEUTRAL, size = PillSize.MD, labelSize, isFilled = false, icon = '', className = '', 'data-testid': dataTestId}: PillProps): ReactElement {
  const isSmall = size === PillSize.SM;

  const getLabelSize = (): TextSize => {
    return labelSize ?? (isSmall ? TextSize.XS : TextSize.SM);
  };

  const renderIcon = (): ReactElement | null => {
    if (!icon) {
      return null;
    }
    return <Icon icon={icon} size={isSmall ? IconSize.SIZE_ICON_14 : IconSize.SIZE_ICON_16} className={styles.content} ariaHidden />;
  };

  return (
    <span className={`${styles.pill} ${styles[type]} ${isSmall ? styles.small : styles.medium} ${isFilled ? styles.filled : ''} ${className}`} data-testid={dataTestId}>
      {renderIcon()}
      <Text val={label} size={getLabelSize()} bold className={styles.content} />
    </span>
  );
}
